import { InfoOutline } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IssueChipProps {
  className?: string;
  count: number;
}

export const IssueChip = ({ className, count }: IssueChipProps) => {
  const { t } = useTranslation();
  return count ? (
    <Chip className={className} icon={<InfoOutline />} color="error" label={t(`IssueChip.label`, { count })} />
  ) : null;
};
